import { GenericService } from "./Generic.service";

class ClinicFrameConfiguracaoService extends GenericService<any> {
  constructor() {
    super();
    this.setUri("ClinicFrameConfiguracao");
  }

  public async getConfiguracao(empresaId: string) {
    return await super.getByResource(`Configuracao/${empresaId}`);
  }

  public async upsertConfiguracao(data: any) {
    return await super.postByResource(data, "Configuracao");
  }

  public async getLogs(empresaId: string, page: number = 1, pageSize: number = 10) {
    let url = `Logs/${empresaId}?page=${page}&pageSize=${pageSize}`;
    return await super.getByResource(url);
  }
}

export default new ClinicFrameConfiguracaoService();
